import { render, staticRenderFns } from "./CandidateGeneralData.vue?vue&type=template&id=3ece682d&scoped=true"
import script from "./CandidateGeneralData.vue?vue&type=script&lang=js"
export * from "./CandidateGeneralData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ece682d",
  null
  
)

export default component.exports